/**
 * Spielerfotos werden vom Kamera-Uploader unter dem eindeutigen Spielnamen abgelegt:
 *   https://www.lasertag-arena-siegen.de/highscores/photos/{YYYYMMDD}-{HHMMSS}-{NNNN}-weste{WW}.jpg
 *
 * Der eindeutige Name ist identisch mit dem Namen der .game-Datei
 * (Startzeit aus dem GAME{}-Kopf + vierstellige Spielnummer).
 */

// Bewusst mit "www." — das ist der vom Betreiber gelieferte, nachweislich
// mit HTTP 200 ausliefernde Hostname für die Fotos. Nicht auf die Variante
// ohne www "korrigieren", sonst riskieren wir, dass die Fotos verschwinden.
const PHOTO_BASE = 'https://www.lasertag-arena-siegen.de/highscores/photos';


/** "20260829192959" + "478" -> "20260829-192959-0478" */
export const buildGameKey = (gameStart: unknown, gameId: unknown): string | null => {
  const start = String(gameStart ?? '').trim();
  const id = String(gameId ?? '').trim();
  if (!/^\d{14}$/.test(start)) return null;
  if (!/^\d{1,4}$/.test(id)) return null;
  return `${start.slice(0, 8)}-${start.slice(8, 14)}-${id.padStart(4, '0')}`;
};

/** Liefert die Foto-URL oder null, wenn der eindeutige Spielname nicht bildbar ist. */
export const buildPlayerPhotoUrl = (
  gameStart: unknown,
  gameId: unknown,
  weste: unknown,
): string | null => {
  const key = buildGameKey(gameStart, gameId);
  const vest = String(weste ?? '').trim();
  if (!key || !/^\d{1,2}$/.test(vest)) return null;
  return `${PHOTO_BASE}/${key}-weste${vest.padStart(2, '0')}.jpg`;
};
